// hooks/useFremdeAusblenden.js — blendet alles außerhalb der App aus
// (Besucher-Chat-Blase aus public/index.html u. ä.), solange die Seite offen
// ist (21.10.2026).
//
// index.html lädt das Chat-Widget auf Hallenschirmen und in der
// Kampfrichter-App gar nicht erst, prüft aber nur die Adresse beim ersten
// Laden. Kommt man innerhalb der App dorthin (z. B. nach der Anmeldung auf
// /judge), hängt die Blase schon an der Seite und lag über den unteren
// Knöpfen. Beim Verlassen der Seite wird sie wieder gezeigt.
import { useEffect } from 'react';

const NICHT = ['SCRIPT', 'STYLE', 'LINK', 'META', 'NOSCRIPT'];

export function useFremdeAusblenden() {
  useEffect(() => {
    const versteckt = new Set();
    const verstecken = () => {
      document.body.querySelectorAll('body > *:not(#root)').forEach((el) => {
        if (NICHT.includes(el.tagName) || versteckt.has(el)) return;
        el.dataset.vorherDisplay = el.style.getPropertyValue('display') || '';
        el.style.setProperty('display', 'none', 'important');
        versteckt.add(el);
      });
    };
    verstecken();
    const beobachter = new MutationObserver(verstecken);
    beobachter.observe(document.body, { childList: true });
    return () => {
      beobachter.disconnect();
      versteckt.forEach((el) => {
        const vorher = el.dataset.vorherDisplay;
        if (vorher) el.style.setProperty('display', vorher); else el.style.removeProperty('display');
        delete el.dataset.vorherDisplay;
      });
    };
  }, []);
}
